"use strict";
import { Reactive } from "@reactively/core";
export function reactively(prototypeOrParams, name, descriptor) {
  if (!prototypeOrParams) {
    return addReactive;
  }
  if (Object.getPrototypeOf(prototypeOrParams) === Object.prototype) {
    return (proto, key, descriptor2) => addReactive(
      proto,
      key,
      descriptor2,
      prototypeOrParams
    );
  } else {
    return addReactive(
      prototypeOrParams,
      name,
      descriptor
    );
  }
}
export class HasReactive {
  __reactive;
  constructor() {
    createReactives(this);
  }
}
export function createReactives(r) {
  const reactives = r.__reactive || (r.__reactive = {});
  for (const { key, descriptor, params } of installList(
    r
  )) {
    const label = `${r.constructor.name}.${key}`;
    const effect = params?.effect;
    if (descriptor?.get) {
      reactives[key] = new Reactive(descriptor.get.bind(r), effect, label);
    } else if (typeof descriptor?.value === "function") {
      const boundFn = descriptor.value.bind(r);
      reactives[key] = new Reactive(boundFn, effect, label);
    } else {
      const initializer = descriptor?.initializer;
      const value = initializer ? initializer.call(r) : void 0;
      reactives[key] = new Reactive(value, effect, label);
    }
    if (params?.equals)
      reactives[key].equals = params.equals;
  }
}
function installList(d) {
  const installEntries = [];
  const installKeys = /* @__PURE__ */ new Set();
  for (let proto = d; proto !== Object.prototype; proto = Object.getPrototypeOf(proto)) {
    if (proto.hasOwnProperty("__toInstall")) {
      proto.__toInstall.forEach((property) => {
        if (!installKeys.has(property.key)) {
          installKeys.add(property.key);
          installEntries.push(property);
        }
      });
    }
  }
  return installEntries;
}
function addReactive(proto, key, descriptor, params = {}) {
  installOneAccessor(proto, key, descriptor);
  queueReactiveToInstall(proto, key, descriptor, params);
  return {};
}
export function queueReactiveToInstall(proto, key, descriptor, params = {}) {
  if (!proto.hasOwnProperty("__toInstall")) {
    Object.defineProperty(proto, "__toInstall", {
      value: []
    });
  }
  proto.__toInstall.push({ key, descriptor, params });
}
function installOneAccessor(proto, key, descriptor) {
  function reactiveGet() {
    return this.__reactive[key].get();
  }
  if (descriptor?.get) {
    Object.defineProperty(proto, key, {
      get: reactiveGet
    });
  } else if (typeof descriptor?.value === "function") {
    proto[key] = reactiveGet;
  } else {
    Object.defineProperty(proto, key, {
      get: reactiveGet,
      set: function(v) {
        return this.__reactive[key].set(v);
      }
    });
  }
}
